(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class SokioProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.mountBelowAddToCart();
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const container = document.createElement('div');
            container.innerHTML = text;
            const recommendations = container.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim()) {
              this.innerHTML = recommendations.innerHTML;
              this.mountBelowAddToCart();
            }
          })
          .catch(() => {});
      }, { rootMargin: '0px 0px 200px 0px' });
      observer.observe(this);
    }

    mountBelowAddToCart() {
      if (!this.isConnected) return;
      const productForm = document.querySelector('.sk-product__form');
      if (productForm && productForm.nextElementSibling !== this) {
        productForm.insertAdjacentElement('afterend', this);
      }
    }
  }
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', SokioProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();
})();
